export async function getTask(axios, category) {
  try {
    const getTaskURL = `ticket/task/?category=${category}`;
    return await axios.get(getTaskURL);
  } catch (e) {
    if (e.response) {
      const errorCode = e.response.data.code;
      if (errorCode === 'submit_failed' || errorCode === 'unknown_error') {
        throw new Error('Form submission fail');
      }
    }
    throw new Error(e?.response?.data?.message);
  }
}

export async function getTaskResponseList(axios, ticketId) {
  try {
    const getTaskURL = `ticket/taskResponse/?ticket=${ticketId}`;
    return await axios.get(getTaskURL);
  } catch (e) {
    if (e.response) {
      const errorCode = e.response.data.code;
      if (errorCode === 'submit_failed' || errorCode === 'unknown_error') {
        throw new Error('Form submission fail');
      }
    }
    throw new Error(e?.response?.data?.message);
  }
}

export async function reSubmitTask(axios, responseId, task, response) {
  try {
    const body = { response, task };
    const postTaskURL = `ticket/taskResponse/${responseId}/`;
    return await axios.put(postTaskURL, body);
  } catch (e) {
    if (e.response) {
      const errorCode = e.response.data.code;
      if (errorCode === 'submit_failed' || errorCode === 'unknown_error') {
        throw new Error('Form submission fail');
      }
    }
    throw new Error(e?.response?.data?.message);
  }
}
